import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function LeadQualityReview({lead,onReviewed}) {
  const [method,setMethod]=useState("consumer_inbound_call");
  const [reference,setReference]=useState("");
  const [contact,setContact]=useState(false);
  const [interest,setInterest]=useState(false);
  const [adult,setAdult]=useState(false);
  const [saving,setSaving]=useState(false);
  const [error,setError]=useState("");
  const [locationMethod,setLocationMethod]=useState("consumer_inbound_call");
  const [locationReference,setLocationReference]=useState("");
  const [locationConfirmed,setLocationConfirmed]=useState(false);
  const verifyLocation=async(e)=>{
    e.preventDefault();
    if(saving||!locationConfirmed||locationReference.trim().length<10)return;
    setSaving(true);setError("");
    try{
      await api.post(`/platform/lead-marketplace/leads/${lead.id}/location-review`,{
        verified_state:"FL",verification_method:locationMethod,
        evidence_reference:locationReference.trim()
      });
      await onReviewed?.();
    }catch(e){setError(formatApiErrorDetail(e?.response?.data?.detail)||"Location review failed.");}
    finally{setSaving(false);}
  };
  if(lead.status==="needs_review"){
    return <form className="mt-3 space-y-2 border-t pt-3" onSubmit={verifyLocation} data-testid="lead-location-review">
      <p className="text-xs font-semibold">Location verification required</p>
      <p className="text-xs text-muted-foreground">The form did not independently verify Florida residence. Do not infer it from advertisement targeting. Verify with the consumer before marking this a qualified Florida Final Expense inquiry.</p>
      <label className="block text-xs">Evidence method
        <select className="mt-1 w-full rounded-md border bg-background p-2" value={locationMethod} onChange={e=>setLocationMethod(e.target.value)}>
          <option value="consumer_inbound_call">Consumer-initiated call</option>
          <option value="consented_reply">Reply to permitted outreach</option>
          <option value="verified_email_response">Verified email response</option>
          <option value="verified_document">Independently verified document</option>
        </select>
      </label>
      <label className="block text-xs">Evidence reference
        <input required minLength={10} maxLength={200} className="mt-1 w-full rounded-md border bg-background p-2"
          value={locationReference} onChange={e=>setLocationReference(e.target.value)}/>
      </label>
      <label className="flex items-start gap-2 text-xs"><input type="checkbox" checked={locationConfirmed}
        onChange={e=>setLocationConfirmed(e.target.checked)}/>
        I independently verified that this consumer lives in Florida. This does not authorize calls, texts or lead sharing.</label>
      <button type="submit" className="rounded-md border px-3 py-2 text-xs disabled:opacity-40"
        disabled={saving||!locationConfirmed||locationReference.trim().length<10}>Record Florida verification</button>
      {error&&<p role="alert" className="text-xs text-destructive">{error}</p>}
    </form>;
  }

  if (lead.status!=="new" || (lead.qualification_status==="qualified"&&lead.sophia?.stage!=="human_review")) {
    return lead.qualification_status==="qualified"
      ? <p className="mt-2 text-xs">Qualified · {lead.qualification_review?.verification_method} · Evidence: {lead.qualification_review?.evidence_reference}</p>
      : null;
  }
  const submit=async(e)=>{
    e.preventDefault();
    if(saving || !contact || !interest || reference.trim().length<10 ||
      (lead.source==="meta_instant_form"&&!adult))return;
    setSaving(true);setError("");
    try{
      await api.post(`/platform/lead-marketplace/leads/${lead.id}/qualification`,{
        verification_method:method,
        evidence_reference:reference.trim(),
        contact_verified:true,
        interest_confirmed:true,
        adult_verified:lead.source==="meta_instant_form"?adult:false
      });
      await onReviewed?.();
    }catch(e){setError(formatApiErrorDetail(e?.response?.data?.detail)||"Qualification review failed.");}
    finally{setSaving(false);}
  };
  return <form className="mt-3 space-y-2 border-t pt-3" onSubmit={submit} data-testid="lead-quality-review">
    <p className="text-xs font-medium">Manual qualification — required before exclusive reservation</p>
    <label className="block text-xs">How was the contact independently verified?
      <select className="mt-1 w-full rounded-md border bg-background p-2" value={method}
        onChange={e=>setMethod(e.target.value)}>
        <option value="consumer_inbound_call">Consumer-initiated call</option>
        <option value="consented_reply">Reply to permitted outreach</option>
        <option value="verified_email_response">Verified email response</option>
      </select>
    </label>
    <label className="block text-xs">Evidence reference (CRM case, recording ID or email thread)
      <input className="mt-1 w-full rounded-md border bg-background p-2" value={reference}
        onChange={e=>setReference(e.target.value)} maxLength={200} required minLength={10}/>
    </label>
    <label className="flex gap-2 text-xs"><input type="checkbox" checked={contact}
      onChange={e=>setContact(e.target.checked)}/>I verified that this consumer can be reached.</label>
    <label className="flex gap-2 text-xs"><input type="checkbox" checked={interest}
      onChange={e=>setInterest(e.target.checked)}/>I confirmed a genuine request for Final Expense information.</label>
    {lead.source==="meta_instant_form"&&<label className="flex gap-2 text-xs"><input type="checkbox" checked={adult}
      onChange={e=>setAdult(e.target.checked)}/>I independently verified this consumer is 18 or older.</label>}
    <button className="rounded-md border px-3 py-2 text-xs disabled:opacity-40"
      disabled={saving||!contact||!interest||reference.trim().length<10||(lead.source==="meta_instant_form"&&!adult)}>
      {saving?"Saving…":"Mark lead qualified"}
    </button>
    {error&&<p className="text-xs text-destructive" role="alert">{error}</p>}
    <p className="text-xs text-muted-foreground">Do not invent verification evidence or contact consumers without appropriate permission. This review is not underwriting or a guarantee of insurance eligibility.</p>
  </form>;
}
